module.exports = __webpack_public_path__ + "img/text_howto.cc14aa9e.png";